import { assignSubComponents } from '@farol-ds/react/utilities/internal'
import classNames from 'classnames'
import React from 'react'

import styles from './chat-input-shell.module.scss'
import { ChatInputShellContent } from './chat-input-shell-content'
import { ChatInputShellDisclaimer } from './chat-input-shell-disclaimer'
import { ChatInputShellForm } from './chat-input-shell-form'
import { ChatInputShellSpacer } from './chat-input-shell-spacer'
import { ChatInputShellSubmitButton } from './chat-input-shell-submit-button'
import { ChatInputShellTextarea } from './chat-input-shell-textarea'
import { ChatInputShellToolbar } from './chat-input-shell-toolbar'

export interface ChatInputShellRootProps {
  children: React.ReactNode
  className?: string
}

function ChatInputShellRoot({ children, className }: ChatInputShellRootProps) {
  return <div className={classNames(styles.root, className)}>{children}</div>
}

export const ChatInputShell = assignSubComponents('ChatInputShell', ChatInputShellRoot, {
  Form: ChatInputShellForm,
  Content: ChatInputShellContent,
  Textarea: ChatInputShellTextarea,
  Toolbar: ChatInputShellToolbar,
  Spacer: ChatInputShellSpacer,
  SubmitButton: ChatInputShellSubmitButton,
  Disclaimer: ChatInputShellDisclaimer,
})
